import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind, type LiquidKind } from '@/play/liquid/kind'
import { isMoonEyeWhite } from './world'

/** Slime is shiny blob voxels (the googly eyes are glossy, so the pour never moves them). */
export const SLIME_LIQUID = liquidKind('blob', { material: 'shiny' })

/**
 * The pour (009's verb, this page's main verb since 2026-10-15): one event per commit; a whole press is one undo step.
 * The coalescer accumulates in place, as 009.
 */
export const SLIME_SETTLE = liquidSettleEvent('experience.moon-slime-2.settle', SLIME_LIQUID)

/**
 * The tuning panel's Glossy switch while pouring: the same pour writing 009's glossy slime. The eye
 * whites are glossy blobs too: they are terrain to it, so the pour never moves an eye.
 */
const GLOSSY_BLOB = liquidKind('blob', { material: 'glossy' })
export const GLOSSY_SLIME_LIQUID: LiquidKind = Object.freeze({
  id: GLOSSY_BLOB.id,
  defaultColor: GLOSSY_BLOB.defaultColor,
  voxel: GLOSSY_BLOB.voxel,
  matches: (v: Parameters<LiquidKind['matches']>[0]) => GLOSSY_BLOB.matches(v) && !isMoonEyeWhite(v),
})
export const GLOSSY_SLIME_SETTLE = liquidSettleEvent('experience.moon-slime-2.settle-glossy', GLOSSY_SLIME_LIQUID)

/** Reducer handlers for Moon slime 2 (`experience.moon-slime-2.*`). */
export const eventHandlers = { ...SLIME_SETTLE.handlers, ...GLOSSY_SLIME_SETTLE.handlers }
